var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReconciliationEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 427,
    viewBox: "0 0 420 427",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203.014 346.891C291.462 346.891 363.168 275.185 363.168 186.421C363.168 97.6573 291.146 25.9512 203.014 25.9512C114.566 25.9512 42.8599 97.6573 42.8599 186.421C42.8599 275.185 114.566 346.891 203.014 346.891Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M352.744 81.2314C359.896 81.2314 365.695 75.4329 365.695 68.2801C365.695 61.1273 359.896 55.3288 352.744 55.3288C345.591 55.3288 339.792 61.1273 339.792 68.2801C339.792 75.4329 345.591 81.2314 352.744 81.2314Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M371.697 30.6896C376.582 30.6896 380.542 26.7296 380.542 21.8448C380.542 16.96 376.582 13 371.697 13C366.812 13 362.852 16.96 362.852 21.8448C362.852 26.7296 366.812 30.6896 371.697 30.6896Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3886 80.9155C56.2735 80.9155 60.2334 76.9556 60.2334 72.0707C60.2334 67.1859 56.2735 63.2259 51.3886 63.2259C46.5038 63.2259 42.5438 67.1859 42.5438 72.0707C42.5438 76.9556 46.5038 80.9155 51.3886 80.9155Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8843 251.494C25.9562 251.494 33.3104 244.14 33.3104 235.068C33.3104 225.996 25.9562 218.642 16.8843 218.642C7.81245 218.642 0.458252 225.996 0.458252 235.068C0.458252 244.14 7.81245 251.494 16.8843 251.494Z",
    fill: "#EAEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M404.938 90.8798C412.371 125.846 411.357 162.83 401.221 197.124C398.856 204.184 396.491 211.917 391.422 217.296C384.327 225.702 371.488 229.4 361.013 226.71C350.201 224.021 341.416 214.607 339.389 203.175C337.7 196.115 340.065 187.71 346.147 183.339C352.566 179.304 361.689 180.313 367.095 185.356C373.177 190.399 375.542 198.132 375.204 205.529C374.866 212.926 372.163 220.322 368.447 226.71C357.297 247.556 337.024 264.03 313.71 271.427C296.478 276.806 277.895 276.806 260.663 272.099",
    stroke: "#C9D4E2",
    strokeWidth: 5.82528,
    strokeMiterlimit: 10,
    strokeDasharray: "11.65 11.65"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M419.128 80.7933C418.114 84.4917 414.06 85.8365 410.005 83.483C405.613 81.4657 402.572 79.7846 403.248 76.4225C404.261 73.0604 408.316 72.7241 413.046 72.3879C418.79 71.7155 419.804 77.0949 419.128 80.7933Z",
    fill: "#DAE2EB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M386.354 84.1556C388.044 87.1815 392.774 89.1988 396.153 86.1729C399.869 82.8107 402.91 80.4572 401.221 77.0951C399.531 74.0691 396.828 75.0778 391.084 75.7502C386.354 76.7589 384.327 80.7934 386.354 84.1556Z",
    fill: "#DAE2EB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M401.221 71.7155C403.586 71.3793 405.951 72.7242 406.627 74.7414C406.964 75.4139 407.302 76.4225 407.302 77.0949C407.978 81.8019 406.289 85.8365 403.586 86.1727C400.545 86.8452 397.504 83.483 397.166 79.1122C397.166 77.7674 397.166 77.0949 397.166 76.0863C397.504 73.7328 398.855 72.0517 401.221 71.7155C401.558 71.7155 401.221 71.7155 401.221 71.7155Z",
    fill: "#989FB0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2078_49855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.995 106.186L314.522 309.617C314.522 316.566 308.836 321.936 301.886 321.936H103.51C96.5607 321.936 90.8748 316.25 90.8748 309.617V48.0634C90.8748 41.1139 96.5607 35.7438 103.51 35.7438H247.238L311.995 106.186Z",
    fill: "url(#paint0_linear_2078_49855)"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M171.518 271.823C176.924 271.823 180.979 267.453 180.979 262.409C180.979 257.03 176.586 252.995 171.518 252.995C166.112 252.995 162.058 257.366 162.058 262.409C161.72 267.453 166.112 271.823 171.518 271.823Z",
    fill: "#989FB0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M246.528 271.487C251.934 271.487 255.988 267.116 255.988 262.073C255.988 256.694 251.596 252.659 246.528 252.659C241.459 252.659 237.067 257.03 237.067 262.073C237.067 267.116 241.122 271.487 246.528 271.487Z",
    fill: "#989FB0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M218.146 281.91H199.9V286.281H218.146V281.91Z",
    fill: "#989FB0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M247.238 35.7438V91.9715C247.238 99.8686 254.188 106.186 262.085 106.186H311.995",
    fill: "#D5DDEA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M271.923 123.627H225.874C225.69 123.627 225.69 123.627 225.506 123.627C225.321 123.627 225.321 123.627 225.137 123.627H177.615C177.431 123.627 177.431 123.627 177.247 123.627C177.062 123.627 177.062 123.627 176.878 123.627H132.119C127.146 123.627 123.093 127.809 123.093 132.718V212.356C123.093 217.447 127.146 221.447 132.119 221.447H271.923C276.896 221.447 280.948 217.447 280.948 212.356V132.718C280.948 127.809 276.896 123.627 271.923 123.627ZM180.01 194.174V176.355H222.743V194.174H180.01ZM222.743 199.629V216.174H180.01V199.629H222.743ZM222.743 152.9V170.901H180.01V153.082H222.743V152.9ZM180.01 147.446V129.082H222.743V147.446H180.01ZM275.423 170.901H228.269V153.082H275.423V170.901ZM174.484 170.901H128.619V153.082H174.484V170.901ZM128.619 176.355H174.484V194.174H128.619V176.355ZM228.269 176.355H275.423V194.174H228.269V176.355ZM275.423 132.718V147.446H228.269V129.082H271.923C273.949 129.082 275.423 130.718 275.423 132.718ZM132.119 129.082H174.484V147.446H128.619V132.718C128.619 130.718 130.093 129.082 132.119 129.082ZM128.619 212.538V199.629H174.484V216.174H132.119C130.277 216.174 128.619 214.538 128.619 212.538ZM271.923 216.174H228.269V199.629H275.423V212.538C275.423 214.538 273.765 216.174 271.923 216.174Z",
    fill: "#C6D0DE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2078_49855",
    x: 21.3799,
    y: 0.996384,
    width: 362.637,
    height: 425.182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 34.7474
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.7474
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2078_49855"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2078_49855",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2078_49855",
    x1: 202.625,
    y1: 29.1239,
    x2: 202.625,
    y2: 325.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReconciliationEmptyState);
export default __webpack_public_path__ + "static/media/reconciliationEmptyState.00f46f6bdf616665987b1c73b1638e96.svg";
export { ForwardRef as ReactComponent };